import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { fortDodgeConfig } from "./data";

export default function FortDodgePage() {
  return <CityPageTemplate config={fortDodgeConfig} />;
}